export function handleResponse(response) {
  if (response.data === "Unauthorized.") throw "Unauthorized";
  return response.data;
}

export function buildRelations(relations) {
  if (relations === null) return null;
  if (relations.length === 0) return null;
  let strings = [];
  relations.forEach(function (relation, index) {
    if (relation.includes("notHas") || relation.includes("has")) {
      relation = relation.split("|");
      strings.push(`${relation[0]}[]=${relation[1]}`);
    } else {
      strings.push(`with[]=${relation}`);
    }
  });
  return strings;
}

export function buildFilters(filters) {
  if (filters === null) return "";
  let strings = [];
  filters.forEach(function (object, index) {
    if (Array.isArray(object)) {
      if (object.length === 1) {
        const { field, operator, value } = object;
        strings.push(buildFilter(index, field, operator, value));
      } else {
        object.forEach(function (subObject, subIndex) {
          const { field, operator, value } = subObject;
          strings.push(buildFilter(index, field, operator, value, true));
        });
      }
    } else {
      const { field, operator, value } = object;
      strings.push(buildFilter(index, field, operator, value));
    }
  });
  return strings;
}

function buildFilter(index, field, operator, value, subFilter = false) {
  // relation queries have to be top level
  if (field && field.includes(".")) {
    if (["isnull", "notnull"].includes(operator)) {
      if (subFilter) return `filters[${index}][]=${field}|${operator}`;
      else return `filters[]=${field}|${operator}`;
    } else {
      if (subFilter) return `filters[${index}][]=${field}|${operator}|${value}`;
      else return `filters[]=${field}|${operator}|${value}`;
    }
  }

  if (["isnull", "notnull"].includes(operator)) {
    if (subFilter) return `filters[${index}][]=${field}|${operator}`;
    else return `filters[${index}][]=${field}|${operator}`;
  } else {
    if (subFilter) return `filters[${index}][]=${field}|${operator}|${value}`;
    else return `filters[${index}][]=${field}|${operator}|${value}`;
  }
}

export function buildOrders(orders) {
  if (orders === null) return "";
  let strings = [];
  orders.forEach(function (object, index) {
    const { field, direction } = object;
    let dir = "asc";
    if (["asc", "desc"].includes(direction)) dir = direction;
    strings.push(`order_by[]=${field}|${dir}`);
  });
  return strings;
}
